import { StudentProblemResult } from '@yandex-int/k-common/typings';
import { Text } from 'platform-components';
import React from 'react';

import { StatItem } from '../lesson-content__stat-item-wrapper';

export const RobotSamples = (props: { studentProblemResult: StudentProblemResult | null }) => {
    const { studentProblemResult } = props;
    const number = studentProblemResult?.problem_specific_data?.finished_samples || 0;
    const max = studentProblemResult?.problem_specific_data?.sample_number;

    return (
        <StatItem>
            <Text id="studentLessonStat.robotSamples" />
            <span className="lesson-content__stat-detail-value">
                {number ? (
                    <Text
                        id="studentLessonStat.robotSamplesValue"
                        values={{
                            number,
                            max,
                        }}
                        weight={Text.WEIGHT.L}
                    />
                ) : (
                    <>&mdash;</>
                )}
            </span>
        </StatItem>
    );
};
